import { Pipe, PipeTransform } from '@angular/core';

/**
 * Пайпа, которая фильтрует массив объектов, передаем ключ и текст фильтрации
 *
 * @example *ngFor="let selected of selectedOptions | gasObjectFilter:'title':form.value"
 */
@Pipe({
  name: 'gasObjectFilter',
  pure: false,
})
export class GasObjectFilterPipe<T> implements PipeTransform {
  public transform(items: T[], key: string, value: string): T[] {
    /** Если чего то нет, то просто возвращаем */
    if (!items || !key || !value) {
      return items;
    }

    /** Фильтруем переданный массив */
    return items.filter((item: T) => item[key]
      .toLowerCase()
      .indexOf(value.toLowerCase()) !== -1);
  }
}
